import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase, ref, set } from "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyA0IiNIHTEmay4jgMnKQTa-P0KFspKkWHQ",
    authDomain: "construlog-339816.firebaseapp.com",
    databaseURL: "https://construlog-339816-default-rtdb.firebaseio.com",
    projectId: "construlog-339816",
    storageBucket: "construlog-339816.appspot.com",
    messagingSenderId: "304893515993",
    appId: "1:304893515993:web:7e2d8106bbfdf1f1f6c6c8",
    measurementId: "G-G7DP7BBXYJ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);
export { app };

// Função para inicializar os planos de assinatura
export const initializeSubscriptionPlans = async () => {
    const plansRef = ref(database, 'subscriptionPlans');

    const defaultPlans = {
        basic: {
            name: 'Básico',
            price: '29.90',
            maxPatients: 5,
            features: [
                '5 Pacientes',
                'Planos Alimentares',
                'Calculadora Nutricional'
            ],
            updatedAt: new Date().toISOString()
        },
        intermediate: {
            name: 'Intermediário',
            price: '59.90',
            maxPatients: 15,
            features: [
                '15 Pacientes',
                'Planos Alimentares',
                'Calculadora Nutricional',
                'Chat com Pacientes',
                'Relatórios'
            ],
            updatedAt: new Date().toISOString()
        },
        advanced: {
            name: 'Avançado',
            price: '99.90',
            maxPatients: -1, // -1 significa ilimitado
            features: [
                'Pacientes Ilimitados',
                'Todas as Funcionalidades',
                'Suporte Prioritário',
                'API Access',
                'Whitelabel'
            ],
            updatedAt: new Date().toISOString()
        }
    };

    try {
        await set(plansRef, defaultPlans);
        console.log('Planos de assinatura inicializados com sucesso!');
    } catch (error) {
        console.error('Erro ao inicializar planos:', error);
    }
};
